import dynamic from 'next/dynamic';
import classNames from 'classnames';
import { useRouter } from 'next/router';

import { Button } from '@com/_atoms/NewButton';
import Icon from '@utilities/icon';
import { colors } from '@configs/Theme';
import VerticalSpecialityCard from '@com/shared/cards/speciality/vertical-speciality-card';
import { routeList } from '@routes/routeList';
import {
  CarouselTexts,
  SPECIALITY_DATA,
  SPECIALITY_WITH_LABEL_ID,
} from '@constant/home';

const ScrollSlider = dynamic(() => import('@com/shared/scroll-slider'));

interface Props {
  containerData?: any;
  containerClassName?: string;
  scrollSliderClassName?: string;
  isShowMoreButton?: boolean;
}

const HomeSpecialityTiles = ({
  containerData,
  containerClassName,
  scrollSliderClassName,
  isShowMoreButton = true,
}: Props) => {
  const { push } = useRouter();

  return (
    <div
      className={classNames('h-auto flex flex-col pb-4', containerClassName)}
      style={
        containerData?.backgroundColor
          ? {
              backgroundColor: containerData?.backgroundColor
                ? containerData?.backgroundColor
                : '',
            }
          : {}
      }
    >
      <div
        className={classNames(
          'h-[48px] flex items-center justify-between px-4',
        )}
        style={
          containerData?.headerBackgroundColor
            ? {
                backgroundColor:
                  containerData?.headerBackgroundColor &&
                  containerData?.headerBackgroundColor,
              }
            : {}
        }
      >
        <div className="flex items-center">
          <span
            className={classNames('text-sm font-semibold text-content-primary')}
          >
            {containerData?.title ? (
              containerData?.title
            ) : (
              <span className="flex items-center gap-x-1">
                مشاوره با پزشک و متخصص
                <span className="text-Body/xSmall text-content-tertiary">{`(متنی و تلفنی)`}</span>
              </span>
            )}
          </span>
        </div>

        {isShowMoreButton && (
          <Button
            variant="secondary"
            size="medium"
            className="h-10 w-10 rounded-full !p-0"
            aria-label="More"
            onClick={() => push(`${routeList?.specialities}?fromHome=true`)}
            icon={
              <Icon
                name="ChevronLeft"
                width={1.5}
                height={1.5}
                fill={colors.black}
              />
            }
          />
        )}
      </div>

      <ScrollSlider
        className={classNames(
          !isShowMoreButton && 'pl-4',
          'flex h-[108px] items-center gap-x-2 px-4 overflow-hidden pt-4',
          scrollSliderClassName,
        )}
      >
        <>
          {SPECIALITY_DATA?.map((item) => {
            return (
              <VerticalSpecialityCard
                hasLabel={SPECIALITY_WITH_LABEL_ID.includes(item.id)}
                onClick={() =>
                  push(
                    `${routeList?.ocsDoctorsList}/${item?.id}?fromHome=true&pageNumber=1&pageSize=10`,
                  )
                }
                specialityData={item}
                key={item?.id}
              />
            );
          })}
        </>

        {isShowMoreButton && (
          <div className="h-[92px] flex flex-col items-start justify-center">
            <div
              onClick={() => push(`${routeList?.specialities}?fromHome=true`)}
              className="min-w-[70px] h-[68px] flex flex-col items-center justify-center cursor-pointer  bg-surface-secondary  rounded-lg"
              onKeyDown={() => {
                return;
              }}
              tabIndex={0}
              role="button"
              aria-label="More"
            >
              <Icon
                name="ArrowLeft"
                width={1.5}
                height={1.5}
                fill={colors?.black}
              />
            </div>
            <span className="text-content-primary text-Label/xSmall text-center w-full">
              {CarouselTexts?.viewAll}
            </span>
          </div>
        )}
      </ScrollSlider>
    </div>
  );
};
export default HomeSpecialityTiles;
